import React, {useEffect, useState} from 'react';
import {Layout, Flex, Space, Row, Col, Typography, Menu, Breadcrumb, Drawer, Button} from 'antd';
import {MenuOutlined, CloseOutlined} from '@ant-design/icons';
import Logo from '../resources/logo.svg';
import FooterLogo from '../resources/e-tech-footer-logo-green.svg';
import {Link, Outlet, useLocation, useNavigate, useParams} from "react-router-dom";
import navPathStore from "../store/NavPath.Store";
import categoryStore from "../store/Category.Store";
import {observer} from "mobx-react-lite";
import useIsMobile from "../framework/MobileCheck";
import http from "../framework/http";

const {Header, Footer, Content} = Layout;
const {Text} = Typography;

function Index() {
    const navigate = useNavigate();
    const [navbarSelected, setNavbarSelected] = useState();
    const [navbarItems, setNavbarItems] = useState();
    const [drawerVisible, setDrawerVisible] = useState(false);
    const [isTablet, setIsTablet] = useState(false);
    const location = useLocation();
    const params = useParams();
    const isMobile = useIsMobile();

    // Check if tablet on mount and resize
    useEffect(() => {
        const checkTablet = () => {
            setIsTablet(window.innerWidth <= 992);
        };

        checkTablet();
        window.addEventListener('resize', checkTablet);
        return () => window.removeEventListener('resize', checkTablet);
    }, []);

    // Close drawer on route change
    useEffect(() => {
        setDrawerVisible(false);
    }, [location.pathname]);

    // Scroll to top on route change
    useEffect(() => {
        // Force immediate scroll to top
        window.scrollTo(0, 0);
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
        
        // Also scroll after a small delay to handle delayed content rendering
        setTimeout(() => {
            window.scrollTo(0, 0);
            document.documentElement.scrollTop = 0;
            document.body.scrollTop = 0;
        }, 0);
    }, [location.pathname, location.key]);

    useEffect(() => {
        // if (location.pathname === '/') {
        //     navPathStore.setNavPath([]);
        //     setNavbarSelected(["HOME"]);
        // } else if (params.categoryId) {
        //     setNavbarSelected([params.categoryId]);
        // }
        if (params.categoryId) {
            setNavbarSelected([params.categoryId]);
        } else {
            navPathStore.setNavPath([]);
            setNavbarSelected([]);
        }
    }, [location])

    // Build hierarchical menu structure
    const buildMenuItems = (categories, parentId = 0) => {
        const categoryArray = [...categories.values()];
        const children = categoryArray.filter(item => item.parentId === parentId);

        return children.map(category => {
            const subChildren = categoryArray.filter(item => item.parentId === category.id);
            const menuItem = {
                label: <Link to={`/category/${category.id}`}>{category.name}</Link>,
                key: String(category.id)
            };

            if (subChildren.length > 0) {
                menuItem.children = buildMenuItems(categories, category.id);
            }

            return menuItem;
        });
    };

    useEffect(() => {
        if (categoryStore.getCategory()) {
            const menuItems = buildMenuItems(categoryStore.getCategory());
            setNavbarItems(menuItems);
        }
    }, [categoryStore.category]);

    const handleMenuClick = () => {
        setDrawerVisible(false);
    };

    const toggleDrawer = () => {
        setDrawerVisible(!drawerVisible);
    };

    const searchModel = async () => {
        //简单匹配型号的keyword字段，忽略空格
        const res = await http.get("/model/search", {params: {keyword: "iphone  15"}});
        if (res.data?.code === 200) {
            console.log(res.data.data);
        }
    }

    return (
        <div>
            <Layout>
                <Header className={`site-header ${isMobile ? 'site-header-mobile' : ''}`}>
                    {(isMobile || isTablet) && (
                        <Button
                            className="hamburger-menu-btn"
                            type="text"
                            icon={<MenuOutlined/>}
                            onClick={toggleDrawer}
                        />
                    )}
                    <div className="header-logo-container">
                        <img
                            src={Logo}
                            alt="Logo"
                            className={`header-logo ${isMobile ? 'header-logo-mobile' : ''}`}
                            onClick={() => navigate('/')}
                        />
                    </div>
                    {!isMobile && !isTablet && (
                        <div className="header-contact-info">
                            <a href="tel:01-534-1721" className="header-phone-link">
                                <Text strong className="header-phone">01-534-1721</Text>
                            </a>
                            <br/>
                            <Text className="header-address">E-Tech, 1 Ballinteer Road, Dundrum, Dublin 16, D16
                                F5T7</Text>
                            <br/>
                            <Text className="header-hours">Opening Hours: Monday - Saturday 10am - 6.00pm</Text>
                        </div>
                    )}
                </Header>

                {/* Mobile/Tablet Drawer Menu */}
                <Drawer
                    title={null}
                    placement="left"
                    onClose={() => setDrawerVisible(false)}
                    open={drawerVisible}
                    className="mobile-menu-drawer"
                    width={280}
                    closeIcon={<CloseOutlined/>}
                >
                    <Menu
                        mode="inline"
                        items={navbarItems}
                        selectedKeys={navbarSelected}
                        className="drawer-menu"
                        onClick={handleMenuClick}
                    />
                    <div className="drawer-contact-info">
                        <a href="tel:01-534-1721" className="drawer-phone-link">
                            <Text strong className="drawer-phone">01-534-1721</Text>
                        </a>
                        <Text className="drawer-address">E-Tech, 1 Ballinteer Road, Dundrum, Dublin 16, D16 F5T7</Text>
                        <Text className="drawer-hours">Opening Hours: Mon - Sat 10am - 6pm</Text>
                    </div>
                </Drawer>

                <Content className="site-content">
                    {!isMobile && !isTablet && (
                        <Menu
                            id="navbar"
                            mode="horizontal"
                            items={navbarItems}
                            selectedKeys={navbarSelected}
                            className="main-menu sticky-menu"
                        />
                    )}
                    {navPathStore.getNavPath().length > 1 && (
                        <Breadcrumb
                            id="navPath"
                            separator=">"
                            items={navPathStore.getNavPath()}
                            className={`nav-breadcrumb ${isMobile ? 'nav-breadcrumb-mobile' : ''}`}
                        />
                    )}
                    <div className="content-outlet"><Outlet/></div>
                </Content>
                <Footer className="site-footer">
                    <div className="footer-social-icons">
                        <a href="https://www.facebook.com/etechdundrum/" target="_blank"
                           rel="noopener noreferrer" className="footer-social-icon">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                            </svg>
                        </a>
                        <a href="https://twitter.com/E_Tech_Ireland" target="_blank"
                           rel="noopener noreferrer" className="footer-social-icon">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
                            </svg>
                        </a>
                    </div>
                    <Row gutter={[48, 32]} className="footer-row">
                        <Col xs={24} sm={8} md={8}>
                            <h3 className="footer-section-title">About E-Tech</h3>
                            <p className="footer-link-item">
                                <Link to="/aboutUs" className="footer-link">About Us</Link>
                            </p>
                            <p className="footer-link-item">
                                <Link to="/contactUs" className="footer-link">Contact Us</Link>
                            </p>
                            <p className="footer-link-item">
                                <Link to="/blogs" className="footer-link">Blogs</Link>
                            </p>
                        </Col>
                        <Col xs={24} sm={8} md={8}>
                            <h3 className="footer-section-title">Repair Enquires</h3>
                            <p className="footer-link-item">
                                <Link to="/contactUs" className="footer-link">Phone Repair</Link>
                            </p>
                            <p className="footer-link-item">
                                <Link to="/contactUs" className="footer-link">Laptop Repair</Link>
                            </p>
                            <p className="footer-link-item">
                                <Link to="/contactUs" className="footer-link">Tablet Repair</Link>
                            </p>
                        </Col>
                        <Col xs={24} sm={8} md={8}>
                            <h3 className="footer-section-title">Terms & Conditions</h3>
                            <p className="footer-link-item">
                                <Link to="/termsAndConditions" className="footer-link">Terms & Conditions</Link>
                            </p>
                            <p className="footer-link-item">
                                <Link to="/privacyPolicy" className="footer-link">Privacy Policy</Link>
                            </p>
                        </Col>
                    </Row>
                    <Row gutter={[48, 32]} className="footer-bottom">
                        <Col xs={24} md={18}>
                            <p className="footer-contact-text">
                                E-Tech, 1 Ballinteer Road, Dundrum, Dublin 16, D16 F5T7
                            </p>
                            <p className="footer-contact-text">
                                For advice, contact us on <a href="tel:01-534-1721" className="footer-phone-link">01-534-1721</a>
                            </p>
                            <p className="footer-contact-text">
                                or email us at <a href="mailto:etechdundrum@gmail.com" className="footer-email-link">etechdundrum@gmail.com</a>.
                            </p>
                            <p className="footer-copyright">
                                © {new Date().getFullYear()} E-Tech Store. All rights reserved
                            </p>
                        </Col>
                        <Col xs={24} md={6}>
                            <div className="footer-logo">
                                <img src={FooterLogo} alt="E-Tech Logo" />
                            </div>
                        </Col>
                    </Row>
                </Footer>
            </Layout>
        </div>
    );
}

export default observer(Index);
